import React, { useCallback, useEffect, useState } from "react";
import { useTabs } from "../../hooks/lib/useTabs";
import { useMobile } from "../../hooks/custom/useMobile";
import {
  IAdmissionPolicyData,
  ICurriculumDevelopmentTeamData,
  ISastTabData,
  IScholarshipsAndFinancialData,
} from "../../exports/interfaces";
import { Link, useLocation } from "react-router-dom";
import { useBrochureContext } from "../../context/BrochureContext";
import { PdfViwer } from "../PdfViwer";
import {
  getVisibleTabs,
  stripHtml,
  truncateText,
} from "../../exports/functions";
import TabSidebar from "../TabSidebar";
import { fetchSASTTabImage } from "../../api/UndergraduateProgramsApi";
import { useLoader } from "../../context/LoaderContext";
import { dynamicFailed } from "../../hooks/custom/useToast";

const UndergraduateTab = (props: {
  sastHighlightsTab: ISastTabData[];
  sastCoreCurriculumTab: ISastTabData[];
  sastAreasOfStudyTab: ISastTabData[];
  sast4YearPlanTab: ISastTabData[];
  curriculumDevelopmentTeam: ICurriculumDevelopmentTeamData[];
  admissionPolicy: IAdmissionPolicyData[];
  scholarshipsAndFinancial: IScholarshipsAndFinancialData[];
}) => {
  useTabs();

  const { setLoading } = useLoader();

  const [tabImage, setTabImage] = useState<
    { image: [{ media: { url: string } }] }[]
  >([]);

  const isMobile = useMobile();

  // const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openSidebar, setOpenSidebar] = useState(false);

  const location = useLocation();

  const { undergraduateBrochureData } = useBrochureContext();

  const [openPdf, setOpenPdf] = useState(false);
  const [pdfPath, setPdfPath] = useState("");

  const openViewer = (path: string) => {
    setPdfPath(path);
    setOpenPdf(true);
  };

  const closeViewer = () => setOpenPdf(false);

  const curriculumDevelopmentSection = (
    <div className="sidebar_item curriculum-development">
      {/* <div
        className={`sidebar_heading ${openMenu ? "sidebar_active" : ""}`}
        onClick={() => setOpenMenu(!openMenu)}
      >
        <div className="sidebar_heading_left">
          <h5
            style={
              mobile || tab
                ? {
                    width: "90%",
                  }
                : {}
            }
          >
            Curriculum Development Team
          </h5>

          <i
            className={`fa-solid fa-chevron-down sidebar_icon ${
              openMenu
                ? `rotate_icon ${!mobile && "ps-2"}`
                : `${!mobile && "pe-2"}`
            }`}
          />
        </div>
      </div> */}

      {/* <div
        className={`sidebar_submenu curriculum-development-submenu ${
          openMenu ? "open mt-3" : "mt-0"
        }`}
      > */}
      <div
        className={`sidebar_submenu curriculum-development-submenu open mt-3`}
      >
        <div className="table-responsive">
          <table className="table table-bordered mt-2 advisors-table">
            <thead>
              <tr>
                <th>
                  <h6 className="mb-0">Name</h6>
                </th>
                <th>
                  <h6 className="mb-0">Email</h6>
                </th>
                <th>
                  <h6 className="mb-0">Courses</h6>
                </th>
              </tr>
            </thead>

            <tbody>
              {props.curriculumDevelopmentTeam.map((member, i) => (
                <tr key={i}>
                  <td className="advisors-row-tint">{member.name}</td>
                  <td>{member.email}</td>
                  <td>{member.courses}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
  const [activeTab, setActiveTab] = useState<string>("#td_tab_1");

  useEffect(() => {
    if (!location.hash) return;

    const hash = location.hash;

    const timer = setTimeout(() => {
      const tabLink = document.querySelector(
        `.td_tab_links a[href="${hash}"]`,
      ) as HTMLAnchorElement | null;

      tabLink?.click();

      const tabsWrapper = document.querySelector(".td_tabs");
      tabsWrapper?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [location.hash]);

  const openTab = (hash: string) => {
    const tabLink = document.querySelector(
      `.td_tab_links a[href="${hash}"]`,
    ) as HTMLAnchorElement | null;

    tabLink?.click();

    const tabsWrapper = document.querySelector(".td_tabs");
    tabsWrapper?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleTabClick = (hash: string) => {
    setActiveTab(hash);
    openTab(hash);
  };

  const [allTabData, setAllTabData] = useState<{
    [key: string]: any[];
  }>({});

  const fetchAllTabData = useCallback(async () => {
    setAllTabData({
      "#td_tab_1": props?.sastCoreCurriculumTab,
      "#td_tab_2": props?.sastAreasOfStudyTab,
      "#td_tab_3": props?.sast4YearPlanTab,
      "#td_tab_4": props.admissionPolicy,
      "#td_tab_5": props.scholarshipsAndFinancial,
    });
  }, [
    props.admissionPolicy,
    props?.sast4YearPlanTab,
    props?.sastAreasOfStudyTab,
    props?.sastCoreCurriculumTab,
    props.scholarshipsAndFinancial,
  ]);

  useEffect(() => {
    fetchAllTabData();
  }, [fetchAllTabData]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchSASTTabImage()])
      .then(([tabImageData]) => {
        setTabImage(tabImageData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  const allTabs = React.useMemo(
    () => [
      {
        id: "#td_tab_1",
        label: "Undergraduate Core Curriculum",
      },
      {
        id: "#td_tab_2",
        label: "Areas of Study",
      },
      {
        id: "#td_tab_3",
        label: "Integrated Four-Year Structure",
      },
      {
        id: "#td_tab_4",
        label: "Admission Policy",
      },
      {
        id: "#td_tab_5",
        label: "Scholarships and Financial Aid",
      },
      {
        id: "#td_tab_6",
        label: "Curriculum Development Team",
      },
    ],
    [],
  );

  const visibleTabs = React.useMemo(() => {
    return getVisibleTabs(allTabs, activeTab, isMobile ? 2 : 3);
  }, [allTabs, activeTab, isMobile]);

  const tabData = allTabData[activeTab] || [];
  return (
    <>
      <section>
        {/* <div className="td_height_120 td_height_lg_80" /> */}
        <div className="container">
          <div className="row td_gap_y_50">
            {/* content */}
            <div className="td_course_details">
              {/* tabs */}
              <div className="td_tabs td_style_1">
                <ul className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_16 td_heading_color align-items-center justify-content-between">
                  {/* <li className="active">
                  <a href="#td_tab_1">Highlights</a>
                </li> */}
                  <div className="td_tab_links td_style_2">
                    {visibleTabs.map((tab) => (
                      <li
                        key={tab.id}
                        className={activeTab === tab.id ? "active" : ""}
                      >
                        <a
                          href={tab.id}
                          onClick={() => handleTabClick(tab.id)}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={tab.label}
                        >
                          {truncateText(tab.label, isMobile ? 10 : 30)}
                        </a>
                      </li>
                    ))}
                  </div>
                  <li>
                    <div className="course_sidebar_toggle_wrapper">
                      <button
                        className="course_sidebar_toggle mt-1"
                        onClick={() => setOpenSidebar(true)}
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                        {/* <span></span>
                  <span></span>
                  <span></span> */}
                      </button>
                    </div>
                  </li>
                </ul>
                <div className="td_tab_body td_fs_18">
                  {/* <div className="td_tab active" id="td_tab_1">
                  <div
                    style={{
                      display: "flex",
                      gap: "25px",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    {isMobile && (
                      <div
                        className="tab-image-wrapper"
                        style={{ width: "100%" }}
                      >
                        <img
                          src={process.env.REACT_APP_cmsUrl + tabImage[0]?.image[0]?.media?.url}
                          alt="student2"
                          height="auto"
                          width="100%"
                        />
                      </div>
                    )}
                    <div
                      className="mb-0"
                      style={{ textAlign: "justify", flex: 1 }}
                    >
                      {props?.sastHighlightsTab?.map((item) => {
                        return (
                          <p>
                            {item?.title && <h5>{item?.title}</h5>}
                            <p
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            />
                          </p>
                        );
                      })}
                    </div>
                    {!isMobile && (
                      <div className="tab-image-wrapper">
                        <img
                          src={process.env.REACT_APP_cmsUrl + tabImage[0]?.image[0]?.media?.url}
                          alt="student2"
                          height="100px"
                          width="auto"
                        />
                      </div>
                    )}
                  </div>
                </div> */}
                  <div
                    className={`td_tab active custom_td_tab ${activeTab === "#td_tab_1" && "active_custom_td_tab"}`}
                    id="td_tab_1"
                  >
                    <div
                    // style={{
                    //   display: "flex",
                    //   gap: "25px",
                    //   flexDirection: isMobile ? "column" : "row",
                    // }}
                    >
                      {isMobile && (
                        <div
                          className="tab-image-wrapper"
                          style={{ width: "100%" }}
                        >
                          <img
                            src={
                              process.env.REACT_APP_cmsUrl +
                              tabImage[0]?.image[0]?.media?.url
                            }
                            alt="student2"
                            height="auto"
                            width="100%"
                          />
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          gap: "25px",
                          flexDirection: isMobile ? "column" : "row",
                        }}
                      >
                        <div
                          className="td_fs_18 w-100 custom-text-p"
                          style={{ flex: 1 }}
                        >
                          {tabData?.map((item) => {
                            return (
                              <p>
                                {item?.title && <h5>{item?.title}</h5>}
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item?.description,
                                  }}
                                />
                              </p>
                            );
                          })}
                        </div>
                        {!isMobile && (
                          <div className="tab-image-wrapper">
                            <img
                              src={
                                process.env.REACT_APP_cmsUrl +
                                tabImage[0]?.image[0]?.media?.url
                              }
                              alt="student2"
                              height="100px"
                              width="auto"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`td_tab active custom_td_tab ${activeTab === "#td_tab_2" && "active_custom_td_tab"}`}
                    id="td_tab_2"
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "25px",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      {isMobile && (
                        <div
                          className="tab-image-wrapper"
                          style={{ width: "100%" }}
                        >
                          <img
                            src={
                              process.env.REACT_APP_cmsUrl +
                              tabImage[0]?.image[0]?.media?.url
                            }
                            alt="student2"
                            height="auto"
                            width="100%"
                          />
                        </div>
                      )}
                      <div className="mb-0 custom-text-p" style={{ flex: 1 }}>
                        {tabData?.map((item) => {
                          return (
                            <p>
                              {item?.title && <h5>{item?.title}</h5>}
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </p>
                          );
                        })}
                      </div>
                      {!isMobile && (
                        <div className="tab-image-wrapper">
                          <img
                            src={
                              process.env.REACT_APP_cmsUrl +
                              tabImage[0]?.image[0]?.media?.url
                            }
                            alt="student2"
                            height="100px"
                            width="auto"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className={`td_tab active custom_td_tab ${activeTab === "#td_tab_3" && "active_custom_td_tab"}`}
                    id="td_tab_3"
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "25px",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      {isMobile && (
                        <div
                          className="tab-image-wrapper"
                          style={{ width: "100%" }}
                        >
                          <img
                            src={
                              process.env.REACT_APP_cmsUrl +
                              tabImage[0]?.image[0]?.media?.url
                            }
                            alt="student2"
                            height="auto"
                            width="100%"
                          />
                        </div>
                      )}
                      <div className="mb-0 custom-text-p" style={{ flex: 1 }}>
                        {tabData?.map((item) => {
                          return (
                            <p>
                              {item?.title && <h5>{item?.title}</h5>}
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: item?.description,
                                }}
                              />
                            </p>
                          );
                        })}
                      </div>
                      {!isMobile && (
                        <div className="tab-image-wrapper">
                          <img
                            src={
                              process.env.REACT_APP_cmsUrl +
                              tabImage[0]?.image[0]?.media?.url
                            }
                            alt="student2"
                            height="100px"
                            width="auto"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className={`td_tab active custom_td_tab ${activeTab === "#td_tab_4" && "active_custom_td_tab"}`}
                    id="td_tab_4"
                  >
                    <div className="mb-0 custom-text-p" style={{ flex: 1 }}>
                      <div style={{ fontSize: "16px" }}>
                        <h4 style={{ textAlign: "center", fontSize: "18px" }}>
                          {tabData[0]?.title}
                        </h4>
                        <h4 style={{ textAlign: "center", fontSize: "18px" }}>
                          {tabData[0]?.sub_title}
                        </h4>

                        <br />

                        <div
                          dangerouslySetInnerHTML={{
                            __html: tabData[0]?.description,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`td_tab active custom_td_tab ${activeTab === "#td_tab_5" && "active_custom_td_tab"}`}
                    id="td_tab_5"
                  >
                    <div className="mb-0 custom-text-p" style={{ flex: 1 }}>
                      <div style={{ fontSize: "16px" }}>
                        <h4 style={{ textAlign: "center", fontSize: "18px" }}>
                          {tabData[0]?.title}
                        </h4>
                        <h4 style={{ textAlign: "center", fontSize: "18px" }}>
                          {tabData[0]?.sub_title}
                        </h4>

                        <br />

                        <div
                          dangerouslySetInnerHTML={{
                            __html: tabData[0]?.description,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`td_tab active custom_td_tab ${activeTab === "#td_tab_6" && "active_custom_td_tab"}`}
                    id="td_tab_6"
                  >
                    {curriculumDevelopmentSection}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="td_height_120 td_height_lg_40"></div>
      </section>
      <section>
        <div className="container d-flex justify-content-center">
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              openViewer(
                undergraduateBrochureData[0]?.file &&
                  undergraduateBrochureData[0]?.file.length > 0
                  ? undergraduateBrochureData[0]?.file[0]?.media?.url
                  : stripHtml(undergraduateBrochureData[0]?.link),
              );
            }}
            className="td_btn td_style_1 td_radius_10 custom-td_style_1 td_medium"
          >
            <span className="td_btn_in custom_td_btn_in">
              <span>View Brochure </span>
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1575 4.34302L3.84375 15.6567"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </Link>
        </div>
        <div className="td_height_120 td_height_lg_40" />
      </section>
      <PdfViwer open={openPdf} onClose={closeViewer} path={pdfPath} />
      <TabSidebar
        title="SAST"
        tabs={allTabs}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
      />
    </>
  );
};

export default UndergraduateTab;
